import { render, staticRenderFns } from "./MessageComment.vue?vue&type=template&id=40261796&scoped=true"
import script from "./MessageComment.vue?vue&type=script&lang=js"
export * from "./MessageComment.vue?vue&type=script&lang=js"
import style0 from "./MessageComment.vue?vue&type=style&index=0&id=40261796&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40261796",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40261796')) {
      api.createRecord('40261796', component.options)
    } else {
      api.reload('40261796', component.options)
    }
    module.hot.accept("./MessageComment.vue?vue&type=template&id=40261796&scoped=true", function () {
      api.rerender('40261796', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/MessageComment.vue"
export default component.exports